import {callApi} from '@/shared/ApiHelper'
import dayjs from 'dayjs'
import {getAssetsByEventId, getPresentersByEventId, showExternalEntities, showFacilitatorGuide} from '@/shared/ApiHelper'

export const checkForAppReload = async function(route, event, apiStore) {
    let reloaded = apiStore.isNewInstance
    if (reloaded) {
        console.log('App reload: recalculating state')
    }
    
    if (false == event.isCached) {
        apiStore.mySchedule = null // Remove any cached personal schedule from other events
        console.log('Cached personal schedule removed, if present')
    }
    if (apiStore.isNewInstance || false == event.isCached) {
        await setNavigationVisibility(event, apiStore)
        apiStore.isNewInstance = false
    }

    return reloaded
}

export const resetApiStore = function(route, apiStore) {
    if (route.query.signout && 'true' == route.query.signout) {
        apiStore.currentAttendee = null
        apiStore.currentEvent = null
        apiStore.currentPresenter = null
        apiStore.displayName = null
        apiStore.events = null
        apiStore.facilitatorGuide = false
        apiStore.isAdmin = false
        apiStore.isStaff = false
        apiStore.mySchedule = null
        apiStore.pastEvents = null
        apiStore.presenters = null
        apiStore.topPastEvents = null
        console.log('apiStore cleared')
    }
}

export const setNavigationVisibility = async function(event, apiStore) {
    apiStore.navigationVisibilities.IsVisibilitySet = false
    apiStore.navigationVisibilities.showCreditLink = false
    apiStore.navigationVisibilities.showFacilitatorGuideLink = false
    apiStore.navigationVisibilities.showExhibitorsLink = false
    apiStore.navigationVisibilities.showMaterialsLink = false
    apiStore.navigationVisibilities.showMyScheduleLink = false
    apiStore.navigationVisibilities.showPartnersLink = false
    apiStore.navigationVisibilities.showPresentersLink = false
    apiStore.navigationVisibilities.showScheduleLink = false
    apiStore.navigationVisibilities.showSponsorsLink = false
    apiStore.navigationVisibilities.showVenuesLink = false

    apiStore.navigationVisibilities.showCreditLink =
        (null != event.credit && '' != event.credit) ||
        (null != event.asha_level && '' != event.ash_level && null != event.asha_ceus && '' != event.ash_ceus)
    apiStore.navigationVisibilities.showFacilitatorGuideLink = showFacilitatorGuide()
    apiStore.navigationVisibilities.showExhibitorsLink = await showExternalEntities(event.id, 'exhibitors')
    apiStore.navigationVisibilities.showMaterialsLink = 0 < (await getAssetsByEventId(event.id)).length
    if (apiStore.navigationVisibilities.showMaterialsLink && !apiStore.isStaff) {
        if (event.visible_date) {
            apiStore.navigationVisibilities.showMaterialsLink = dayjs() >= dayjs(event.visible_date) && apiStore.isRegisteredForCurrentEvent
        }
    }
    apiStore.navigationVisibilities.showPartnersLink = await showExternalEntities(event.id, 'partners')
    apiStore.navigationVisibilities.showPresentersLink = 0 < (await getPresentersByEventId(event.id)).length
    if (apiStore.isStaff) {
        apiStore.navigationVisibilities.showScheduleLink = true
    } else {
        apiStore.navigationVisibilities.showScheduleLink = false
        const response = await callApi(apiStore.buildUrl('/events/sessions/?event=' + event.id))
        const sessions = response.data
        for (let i = 0; i < sessions.length; ++i) {
            if (sessions[i].is_published) {
                apiStore.navigationVisibilities.showScheduleLink = true
                break
            }
        }
    }
    apiStore.navigationVisibilities.showMyScheduleLink = apiStore.navigationVisibilities.showScheduleLink && event.personal_schedules
    apiStore.navigationVisibilities.showSponsorsLink = await showExternalEntities(event.id, 'sponsors')
    if ('virtual' == event.format) {
        apiStore.navigationVisibilities.showVenuesLink = false
    } else {
        const response = await callApi(apiStore.buildUrl('/events/venues/?event=' + event.id))
        const venues = response.data
        apiStore.navigationVisibilities.showVenuesLink = Array.isArray(venues) && 0 < venues.length
    }
    apiStore.navigationVisibilities.isVisibilitySet = true
    console.log('Navigation visibility set')
}

export const setRegistrationStatus = async function(apiStore) {
    apiStore.isPaidForCurrentEvent = false
    apiStore.isRegisteredForCurrentEvent = false
    const response = await callApi(apiStore.buildUrl('/events/attendees/?event=' + apiStore.currentEvent.event.id + '&a=' + apiStore.oid))
    if (Array.isArray(response.data) && 0 < response.data.length) {
        apiStore.isRegisteredForCurrentEvent = true
        const eventAttendee = response.data[0]
        if (false == eventAttendee.is_payment_required || true == eventAttendee.is_paid) {
            apiStore.isPaidForCurrentEvent = true
        }
    }
}